var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9CFEB997-9457-4C74-8A55-94B14F6204D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,1 C8.1045695,1 9,1.8954305 9,3 L9,7 C9,8.1045695 8.1045695,9 7,9 L3,9 C1.8954305,9 1,8.1045695 1,7 L1,3 C1,1.8954305 1.8954305,1 3,1 L7,1 Z M7,3 L3,3 L3,7 L7,7 L7,3 Z M17,1 C18.1045695,1 19,1.8954305 19,3 L19,7 C19,8.1045695 18.1045695,9 17,9 L13,9 C11.8954305,9 11,8.1045695 11,7 L11,3 C11,1.8954305 11.8954305,1 13,1 L17,1 Z M17,3 L13,3 L13,7 L17,7 L17,3 Z M7,11 C8.1045695,11 9,11.8954305 9,13 L9,17 C9,18.1045695 8.1045695,19 7,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,13 C1,11.8954305 1.8954305,11 3,11 L7,11 Z M7,13 L3,13 L3,17 L7,17 L7,13 Z M17,11 C18.1045695,11 19,11.8954305 19,13 L19,17 C19,18.1045695 18.1045695,19 17,19 L13,19 C11.8954305,19 11,18.1045695 11,17 L11,13 C11,11.8954305 11.8954305,11 13,11 L17,11 Z M17,13 L13,13 L13,17 L17,17 L17,13 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-20.000000, -71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Dashboard",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#0883EF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarDashboardActive);
export default __webpack_public_path__ + "static/media/ic-sidebar-dashboard-active.2377033fe7adde1bbd45fbb467823af5.svg";
export { ForwardRef as ReactComponent };